import { createContext } from 'react';

export const DataListContext = createContext({});

